import { Unsubscribe } from "modules/sections/Unsubscribe";
import type { UnsubscribeProps } from "modules/sections/Unsubscribe";
import type { ReactStoryblokComponent } from "types/storyblok";

export const UnsubscribeAdapter = ({
  blok: { confirmationMessage, ctaText, successMessage, errorMessage },
  sbEditable,
}: ReactStoryblokComponent<UnsubscribeProps>) => (
  <Unsubscribe
    errorMessage={errorMessage}
    confirmationMessage={confirmationMessage}
    ctaText={ctaText}
    successMessage={successMessage}
    sbEditable={sbEditable}
  />
);
